import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  CheckboxGroup as AriaCheckboxGroup,
  CheckboxGroupProps,
} from "react-aria-components";

import { sharedStyles } from "../../../styles";

export function _CheckboxGroup(props: CheckboxGroupProps) {
  const className = css(sharedStyles.field, styles.checkboxGroup);

  return <AriaCheckboxGroup {...mergeProps(props, { className })} />;
}

const styles = {
  checkboxGroup: css({ gap: "var(--space-2)" }),
};
